import type React from 'react';

export interface SessionTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'muted';
  truncate?: boolean;
}

const sizeClasses = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base'
};

const variantClasses = {
  default: 'text-text-primary font-medium',
  muted: 'text-text-muted font-normal'
};

export default function SessionTitle({
  children,
  size = 'md',
  variant = 'default',
  truncate = true,
  className = '',
  ...props
}: SessionTitleProps) {
  return (
    <h3
      className={`${sizeClasses[size]} ${variantClasses[variant]} ${
        truncate ? 'truncate' : ''
      } ${className}`}
      {...props}
    >
      {children}
    </h3>
  );
}